export default __webpack_public_path__ + "static/media/logo-lumina.cc035820.png";